export const GLOBAL_SEARCH_OPEN = 'GLOBAL_SEARCH_OPEN';

export const openGlobalSearch = () => ({
  type: GLOBAL_SEARCH_OPEN,
});
